export default __webpack_public_path__ + "static/media/europe-icon.89a2f5e8.png";